import React, { useState, useEffect } from "react";
import axiosClient from "../../utilities/axios_client";
import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  Link,
  BackLink,
} from "../../groundworkui-ui";

const UiKitConfigurationsIndex = ({ projectId }) => {
  const [uiKitConfigurations, setUiKitConfigurations] = useState([]);

  const loadUiKitConfigurations = () => {
    axiosClient
      .get(`/projects/${projectId}/ui_kit_configurations`)
      .then((response) => {
        setUiKitConfigurations(response.data);
      });
  };

  useEffect(() => {
    loadUiKitConfigurations();
  }, []);

  return (
    <div>
      <BackLink href={`/projects/${projectId}`} />
      <h1>Versions</h1>
      <Table>
        <TableBody>
          {uiKitConfigurations.map((uiKitConfiguration) => {
            return (
              <TableRow>
                <TableCell key={uiKitConfiguration.id}>
                  <div>Version {uiKitConfiguration.version}</div>
                  <div>{uiKitConfiguration.created_at}</div>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};

export default UiKitConfigurationsIndex;
